import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

const AuthForm = ({input1, input2, handleSubmit, buttonText, showPasswordReset = false, title = ""}) => {
    const {t} = useTranslation();

    // noinspection AllyJsxHardcodedStringInspection
    return (
        <div className="w-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-xs">
            <div className={`grid grid-cols-2 text-center`}>
                <div className="col">
                    <img src={"/static/image/logo/barzettes.png"} alt="Les Barzettes" className="h-24"/>
                </div>
                <div className="col h-full flex justify-center">
                    <img src={"/static/image/logo/mont-bonvin.png"} alt="Mont-Bonvin Mollens"
                         className="h-20 my-auto align-middle"/>
                </div>
                <div className="col col-span-2 my-5">
                    <h1 className="font-bold">{t("auth.titre")}</h1>
                </div>
            </div>
            <form className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 border" onSubmit={handleSubmit}>
                <h6 className="font-bold text-center text-md mb-4">{title}</h6>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={input1.id}>
                        {input1.label}
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id={input1.id} type={input1.type} placeholder={input1.placeholder}
                        required={input1.required ?? true} value={input1.value}
                        onChange={input1.onChange} disabled={input1.disabled ?? false}/>
                </div>
                {input2 && <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={input2.id}>
                        {input2.label}
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id={input2.id} type={input2.type} placeholder={input2.placeholder}
                        required={input2.required ?? true} value={input2.value}
                        onChange={input2.onChange} disabled={input2.disabled ?? false}/>
                </div>}
                <div className="flex items-center justify-between">
                    <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                        type="submit">
                        {buttonText}
                    </button>
                </div>
            </form>
            {showPasswordReset && <div className="text-center p-2">
                <Link to={`/reinitialiser-acces`}>{t("auth.reset")}</Link>
            </div>}
        </div>
    );
}

export default AuthForm;
